import { Injectable } from '@angular/core';

@Injectable()
export class CustomValidatorsService {
	constructor(){}
	/*areEqual(group: any) {
	    let val;
	    let valid = true;
	    for (let item in group.controls) {
	      if (val === undefined) {
	        val = group.controls[item].value;
	      } else {
	        if (val !== group.controls[item].value) {
	          valid = false;
	          break;
	        }
	      }
	    }
	    if (valid) {
	      return null;
	    }
	    return {
	      areEqual: true
	    };
  	}*/  	
	isValidEmail(control: any) {
		let emailRegex = /^[a-z0-9_\-\.]{2,}@[a-z0-9_\-\.]{2,}\.[a-z]{2,}$/i;
	    let valid = false;
	    if (emailRegex.test(control['value'])) {
	        valid = true;
	    }
	    if (valid) {
		   	return null;
	    }
	    return {
	      isValidEmail: true
	    };
  	}  
	isNumeric(control: any) {
		let numberRegex = /^[1-9][0-9]*$/;
	    let valid = false;
	    if (numberRegex.test(control['value'])) {
	        valid = true;
	    }
	    if (valid) {
	      return null;
	    }
	    return {
	      isNumeric: true
	    };
		}
		isPhoneNumberNumeric(control: any) {
			let numberRegex = /^[0-9][0-9]*$/;
				let valid = false;
				if (numberRegex.test(control['value'])) {
						valid = true;
				}
				if (valid) {
					return null;
				}
				return {
					isNumeric: true
				};
			}
  	noWhitespace(control: any) {
		let isWhitespace = (control['value'] || '').trim().length === 0;
    	let isValid = false;
	    if (!isWhitespace) {
	        isValid = true;
	    }
	    if (isValid) {
	      return null;
	    }
	    return {
	      noWhitespace: true
	    };
	  }
	  validZipCode(control: any){
		let value = (control['value'])
		/*if (value && value.legth >0 ){
			this.noWhitespace(control);
			this.isNumeric(control);
		}*/
	  }
	  isValidLength(control: any){
		let valid=true ;
		let value = (control['value'])
		if (value && value.length < 8 ){
			valid =false;
			
		}
		if (valid) {
			return null;
		}
		else{
			return {
				isValidLength: true
			};
		}
		
	  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/custom-validators.service.ts